/**
 * Models a single column
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    name: String,
    elementId: String,
    tooltip: String,
    searchable: Boolean,
    orderable: Boolean,
    visible: Boolean,
    type: String,
  },

  defaults: {
    name: null,
    elementId: null,
    tooltip: null,
    searchable: false,
    orderable: false,
    visible: true,
    type: "string",
  },

  initialize() {
    const valid = this.isValid();
    if (!valid) {
      console.warn(this.validationError, this.toJSON());
    }
  },

  validate(attrs) {
    // name is required
    if (_.isEmpty(attrs.name)) {
      return "Column name is missing.";
    }

    // elementId is required
    if (_.isEmpty(attrs.elementId)) {
      return "Column element ID is missing.";
    }
  },
});

export { Model as default };
